// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyC45gCWJgbRXXZ8SF1mTC82gurZlaTmtRs",
    authDomain: "trysil-sykkelservice-stage.firebaseapp.com",
    databaseURL: "https://trysil-sykkelservice-stage.firebaseio.com",
    projectId: "trysil-sykkelservice-stage",
    storageBucket: "trysil-sykkelservice-stage.appspot.com",
    messagingSenderId: "283113659168"
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts